import { createSelector } from 'reselect';
import PredesComplianceMissingRequiredElementsSummaryColumns
  from '../../containers/PredesComplianceMissingRequiredElementsSummaryColumns';
import ReportDefinitions from '../../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMissingRequiredElementsSummaryColumns);
